/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

const $Reader = $protobuf.Reader, $util = $protobuf.util;

const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const WidevinePsshData = $root.WidevinePsshData = (() => {

    function WidevinePsshData(p) {
        this.keyIds = [];
        this.groupIds = [];
        this.entitledKeys = [];
        if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                if (p[ks[i]] != null)
                    this[ks[i]] = p[ks[i]];
    }

    WidevinePsshData.prototype.keyIds = $util.emptyArray;
    WidevinePsshData.prototype.contentId = "";
    WidevinePsshData.prototype.cryptoPeriodIndex = 0;
    WidevinePsshData.prototype.protectionScheme = 0;
    WidevinePsshData.prototype.cryptoPeriodSeconds = 0;
    WidevinePsshData.prototype.type = 0;
    WidevinePsshData.prototype.keySequence = 0;
    WidevinePsshData.prototype.groupIds = $util.emptyArray;
    WidevinePsshData.prototype.entitledKeys = $util.emptyArray;
    WidevinePsshData.prototype.algorithm = 0;
    WidevinePsshData.prototype.provider = "";
    WidevinePsshData.prototype.trackType = "";
    WidevinePsshData.prototype.policy = "";
    WidevinePsshData.prototype.groupedLicense = $util.newBuffer([]);

    WidevinePsshData.decode = function decode(r, l) {
        if (!(r instanceof $Reader))
            r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $root.WidevinePsshData();
        while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
            case 2:
                if (!(m.keyIds && m.keyIds.length))
                    m.keyIds = [];
                m.keyIds.push(r.bytes());
                break;
            case 4:
                m.contentId = r.string();
                break;
            case 7:
                m.cryptoPeriodIndex = r.uint32();
                break;
            case 9:
                m.protectionScheme = r.uint32();
                break;
            case 10:
                m.cryptoPeriodSeconds = r.uint32();
                break;
            case 11:
                m.type = r.int32();
                break;
            case 12:
                m.keySequence = r.uint32();
                break;
            case 13:
                if (!(m.groupIds && m.groupIds.length))
                    m.groupIds = [];
                m.groupIds.push(r.bytes());
                break;
            case 14:
                if (!(m.entitledKeys && m.entitledKeys.length))
                    m.entitledKeys = [];
                m.entitledKeys.push($root.WidevinePsshData.EntitledKey.decode(r, r.uint32()));
                break;
            case 1:
                m.algorithm = r.int32();
                break;
            case 3:
                m.provider = r.string();
                break;
            case 5:
                m.trackType = r.string();
                break;
            case 6:
                m.policy = r.string();
                break;
            case 8:
                m.groupedLicense = r.bytes();
                break;
            default:
                r.skipType(t & 7);
                break;
            }
        }
        return m;
    };

    WidevinePsshData.Type = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SINGLE"] = 0;
        values[valuesById[1] = "ENTITLEMENT"] = 1;
        values[valuesById[2] = "ENTITLED_KEY"] = 2;
        return values;
    })();

    WidevinePsshData.EntitledKey = (function() {

        function EntitledKey(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        EntitledKey.prototype.entitlementKeyId = $util.newBuffer([]);
        EntitledKey.prototype.keyId = $util.newBuffer([]);
        EntitledKey.prototype.key = $util.newBuffer([]);
        EntitledKey.prototype.iv = $util.newBuffer([]);
        EntitledKey.prototype.entitlementKeySizeBytes = 32;

        EntitledKey.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.WidevinePsshData.EntitledKey();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.entitlementKeyId = r.bytes();
                    break;
                case 2:
                    m.keyId = r.bytes();
                    break;
                case 3:
                    m.key = r.bytes();
                    break;
                case 4:
                    m.iv = r.bytes();
                    break;
                case 5:
                    m.entitlementKeySizeBytes = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return EntitledKey;
    })();

    WidevinePsshData.Algorithm = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNENCRYPTED"] = 0;
        values[valuesById[1] = "AESCTR"] = 1;
        return values;
    })();

    return WidevinePsshData;
})();

export { $root as default };
